import { useLocation } from 'react-router-dom'
import { Breadcrumb } from '@/components/common/Breadcrumb'

/**
 * Placeholder for feature routes not yet implemented.
 */
export function PlaceholderPage(): React.ReactElement {
  const path = useLocation().pathname.replace(/^\//, '') || 'page'
  const title = path.charAt(0).toUpperCase() + path.slice(1).replace(/-/g, ' ')

  return (
    <div className="space-y-6">
      <Breadcrumb
        items={[
          { label: 'Organization', to: '/dashboard' },
          { label: title },
        ]}
      />
      <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">{title}</h1>
      <p className="mt-2 text-gray-600 dark:text-gray-400">This section is not implemented yet.</p>
    </div>
  )
}
